export const sidebarMenusItems = [
  {
    name: 'Revenue Centers',
    link: '/revenue-centers',
  },
  {
    name: 'Items',
    link: '/items',
  },
  {
    name: 'Display Categories',
    link: '/categories',
  },
  {
    name: 'Reporting Categories',
    link: '/reporting-categories',
  },
  {
    name: 'Modifier Groups',
    link: '/modifier-groups',
  },
  {
    name: 'Sales Events',
    link: '/sales-events',
  },
  {
    name: 'Price Levels',
    link: '/price-levels',
  },
]

export const sidebarSettingsItems = [
  {
    name: 'Venue Settings',
    link: '/venue-settings',
  },
  {
    name: 'Merchants',
    link: '/merchants',
  },
  {
    name: 'Custom Tenders',
    link: '/custom-tenders',
  },
  {
    name: 'POS Accounts',
    link: '/pos-accounts',
  },
]
